import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {loginUiTexts} from 'data/ui-texts';

import {gamesData} from 'data/games-data';
import {getText} from 'helpers/language-helper';
import Logo from 'components/logo/logo';
import LoginGroupController from '../login-default/login-group/login-group-controller';
import LoginOpenIdFacilitator from './login-facilitator/login-open-id-facilitator';
import './login-open-id.scss';

const LoginOpenId = ({languageId, gameType, authErrMsg, companyData}) => {
	/* Active login box */
	const [activeLoginBox, setActiveLoginBox] = useState('facilitator');

	/* Game title */
	const gameTitle = (gamesData.hasOwnProperty(gameType) 
		? getText(gamesData[gameType].titleOverview, languageId) 
		: ''
	);

	return (
		<div className={'LoginOpenId ' + activeLoginBox}>
			<Logo classes={['login']} />
			<div className="LoginOpenId-gameTitle">{gameTitle}</div>
			<div className="LoginOpenId-tabContainer">
				<div
					className={'LoginOpenId-tabButton' + (activeLoginBox === 'facilitator' ? ' active' : '')}
					onClick={() =>{setActiveLoginBox('facilitator');}}
				>{getText(loginUiTexts.facilitator, languageId)}</div>
				<div
					className={'LoginOpenId-tabButton' + (activeLoginBox === 'group' ? ' active' : '')}
					onClick={() =>{setActiveLoginBox('group');}}
				>{getText(loginUiTexts.group, languageId)}</div>
			</div>
			<div className="LoginOpenId-formContainer">
				{activeLoginBox === 'facilitator' && 
					<LoginOpenIdFacilitator 
						languageId={languageId} 
						authErrMsg={authErrMsg} 
						companyData={companyData} 
					/>}
				{activeLoginBox === 'group' && 
						<LoginGroupController languageId={languageId} gameType={gameType} />}
			</div>
			<div className='LoginOpenId-logo' onClick={() => {window.open('https://cphgamelab.dk/', '_blank', 'noopener,noreferrer');}} ></div>
		</div>
	);
};

LoginOpenId.propTypes = {
	languageId: PropTypes.string.isRequired,
	gameType: PropTypes.string.isRequired,
	authErrMsg: PropTypes.string,
	companyData: PropTypes.object
};

export default LoginOpenId;